import type { GovernanceUser } from "./schemas";

export const ROLE_LABELS: Record<string, string> = {
  user: "User",
  admin: "Admin",
  super_admin: "Super Admin",
};

const collator = new Intl.Collator(undefined, {
  sensitivity: "base",
  numeric: true,
});

/**
 * Orders the Users tab by the name each card shows, then by email, then by uid.
 *
 * A user with no name sorts under their email, which is what their card shows
 * as its heading, so the list reads alphabetically as displayed.
 */
export function compareUsers(a: GovernanceUser, b: GovernanceUser): number {
  return (
    collator.compare(a.name || a.email || a.uid, b.name || b.email || b.uid) ||
    collator.compare(a.email ?? "", b.email ?? "") ||
    collator.compare(a.uid, b.uid)
  );
}

/** The fields the Users tab search looks in. */
export function userSearchFields(
  user: GovernanceUser,
): Array<string | undefined> {
  const role = user.platformRole ?? "user";
  return [
    user.name,
    user.email,
    user.company,
    user.jobTitle,
    // Both the stored value and the label, so "super_admin" and
    // "super admin" find the same people.
    role,
    ROLE_LABELS[role],
  ];
}
